<template>
  <AdminDashboard v-if="currentUser?.user_role.includes(UserRoles.ADMIN)" />

  <RolesDashboard v-else />
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user.store';
import { storeToRefs } from 'pinia';
import AdminDashboard from './AdminDashboard/index.vue';
import RolesDashboard from './RolesDashboard.vue';
import { UserRoles } from '@/_helpers/interfaces';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';

const { currentUser } = storeToRefs(useUserStore());
const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.dashboard',
    },
  ]);
});
</script>
